import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IGridCard, MasonrySettings } from '../FilterableGridModule.types';

import FilterableGrid from '../FilterableGrid/FilterableGrid.vue';

@Component({
  components: {
    FilterableGrid,
  },
})
export default class FilterableGridMasonry extends Vue {
  @Prop()
  readonly cards!: IGridCard[];

  @Prop()
  readonly masonry: MasonrySettings;

  get TopCards() {
    return this.cards.filter((c: any) => c[this.masonry.MasonryField]).slice(0, 3);
  }

  get MainCards() {
    return this.cards.filter((c: any) => !c[this.masonry.MasonryField]);
  }
}
